import { Box, Card, CircularProgress, Stack, Typography } from '@mui/material';

import { Icon } from '@karehero/llama/components/atoms/Icon/Icon';

import { type DocItem } from '@/karehero-app/care/fixtures';

// Wrapper component: a document row — file icon + name + kebab menu, or a
// spinner instead of the kebab while the file is still uploading.
const DocRow = ({
  doc,
  onMenu,
}: {
  doc: DocItem;
  onMenu?: (doc: DocItem) => void;
}) => (
  <Card sx={{ p: 2 }}>
    <Stack sx={{ alignItems: 'center' }} direction='row' spacing={1.5}>
      <Box sx={{ color: 'primary.main', display: 'flex' }}>
        <Icon icon='file-lines' fontSize={20} />
      </Box>
      <Typography sx={{ flex: 1, minWidth: 0 }} variant='body1' noWrap>
        {doc.name}
      </Typography>
      {doc.uploading ? (
        <CircularProgress size={20} color='primary' />
      ) : (
        <Box
          onClick={() => onMenu?.(doc)}
          sx={{
            color: 'custom.neutral.500',
            display: 'flex',
            cursor: onMenu ? 'pointer' : 'default',
          }}
        >
          <Icon icon={'ellipsis-vertical' as never} fontSize={18} />
        </Box>
      )}
    </Stack>
  </Card>
);

export default DocRow;
